import {Device, DeviceLogin} from "./types";
import {getDevicesLoginUrl, getDevicesSetupUrl, getDevicesTeardownUrl} from "../libwyze-shared/types";
import {
  DevicesLoginResponse,
  DevicesSetupRequest,
  DevicesSetupResponse,
  DevicesTeardownRequest
} from "../libwyze-common/api/types";
import {JSON_OBJECT} from "../common/json/helpers";
import {BaseResponse} from "../common/types";

export class CheckinApi {

  private static instance: CheckinApi;

  static getInstance(): CheckinApi {
    if (!CheckinApi.instance) {
      CheckinApi.instance = new CheckinApi();
    }
    return CheckinApi.instance;
  }

  private constructor() {
  }

  async devicesLogin(deviceUnitId: string): Promise<DeviceLogin | undefined> {
    let login: DeviceLogin;
    const resp = await (await fetch(getDevicesLoginUrl(deviceUnitId))).json() as DevicesLoginResponse;
    if (resp) {
      login = JSON_OBJECT.deserializeObject(resp.login, DeviceLogin);
    }
    return login;
  }

  async devicesSetup(practiceId: string, setupCode: string): Promise<Device | undefined> {
    let device: Device;
    const resp = await (await fetch(getDevicesSetupUrl(), {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        practiceId,
        setupCode,
      } as DevicesSetupRequest),
    })).json() as DevicesSetupResponse;
    if (resp) {
      device = JSON_OBJECT.deserializeObject(resp.device, Device);
    }
    return device;
  }

  async devicesTeardown(practiceId: string, deviceId: string): Promise<void> {
    await fetch(getDevicesTeardownUrl(), {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        practiceId,
        deviceId,
      } as DevicesTeardownRequest),
    });
  }
}